import { Outlet } from "@tanstack/react-router";
import type { JSX } from "react";

import { SiteFooter } from "@/components/SiteFooter";
import { SiteHeader } from "@/components/SiteHeader";
import { ThemeProvider } from "@/components/ThemeProvider";
import { Toaster } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";

export const RootLayout = (): JSX.Element => (
  <ThemeProvider>
    {/* The app mounts its tooltip provider once at the root too, and its default
        of delayDuration={0} is what makes tips feel immediate rather than laggy. */}
    <TooltipProvider>
      <div className="flex min-h-svh flex-col">
        <SiteHeader />
        <main className="flex flex-1 flex-col">
          <Outlet />
        </main>
        <SiteFooter />
      </div>
      <Toaster />
    </TooltipProvider>
  </ThemeProvider>
);
